import * as React from "react";
import { GameHandlers } from "./game.handlers";
import { GameStateModel } from "../models/game/gameState.model";
import { CreateGameResponse } from "../socket/socket.responses";

const throwNotImplementedError = () => {
  throw new Error("Function not implemented");
};

export const GameContext = React.createContext<[GameStateModel, GameHandlers]>([
  {
    token: null,
    votingFinished: false,
  },
  {
    createGame: () => new Promise<CreateGameResponse>(() => null),
    joinGame: throwNotImplementedError,
    castVote: throwNotImplementedError,
    chooseFinalResult: throwNotImplementedError,
    getVotingSystems: throwNotImplementedError,
    getLocalToken: throwNotImplementedError,
    reconnectToGame: throwNotImplementedError,
    createTimer: throwNotImplementedError,
    addTime: throwNotImplementedError,
    cancelTime: throwNotImplementedError,
    resetTimer: throwNotImplementedError,
    updateUser: throwNotImplementedError,
    revealVotes: throwNotImplementedError,
    startNewVoting: throwNotImplementedError,
    finishGame: throwNotImplementedError,
    addTask: throwNotImplementedError,
    updateTask: throwNotImplementedError,
    removeTask: throwNotImplementedError,
  },
]);
